module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Gd-Ha-Ia-outside.38a06d45.png";